import { Text } from '@mantine/core';
import { MetricWrapper, MetricWrapperProps } from './wrapper';

type MetricProps = {
	title: string;
	value: string;
} & MetricWrapperProps;

export function MetricCard({ title, value, ...rest }: MetricProps) {
	return (
		<MetricWrapper {...rest}>
			<Text fz="md" fw="500">
				{title}
			</Text>
			<Text fz="lg" fw="bold">
				{value}
			</Text>
		</MetricWrapper>
	);
}
